module.exports = __webpack_public_path__ + "static/img/layer4.568168f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/layer4.png
// module id = a8Vg
// module chunks = 1